<template>
  <EditorPromoCode v-bind="{ options }" />
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  lotteryId: LotteryId
}

const { lotteryId } = defineProps<Props>()

const options = useEditorLotteryPromoCodeOptions(lotteryId)
</script>
